<template>
    <views class="shop">
        <nav-bar
            title="附近门店"
            right-text=""
            fixed
            @click-left="onClickLeft"
            @click-right="onClickRight">
        </nav-bar>
        <filter-bar
            :list="shopList"
            @map="handleMap"
            @citychange="onCityChange"
            @address="onGetAddressInfo"
            @doQuery="getShopList">
        </filter-bar>
        <views class="line"></views>
        <views
            v-if="shopList.length > 0"
            class="shop-body">
            <shop-item
                v-for="(item, index) in shopList"
                :key="index"
                :item="item"
                @click="handleDetail"
                @addr="handleAddr">
            </shop-item>
        </views>
        <views
            v-else
            class="empty">
            {{ emptyTitle }}
        </views>
    </views>
</template>

<script>
import ShopItem from '@/components/shopItem'
import NavBar from '@/components/navBar'
import FilterBar from './FilterBar'
import tools from '@/mixins/tools'
import api from '@/utils/api'
export default {
    components: {
        NavBar,
        ShopItem,
        FilterBar
    },
    mixins: [tools],
    data() {
        return {
            shopList: [],
            shopLoading: true,
            posP: '', // 当前选择省
            posC: '' // 当前选择市
        }
    },
    computed: {
        emptyTitle() {
            return this.shopLoading ? '门店信息加载中.....' : '该区域暂无门店'
        }
    },
    methods: {
        onCityChange(address) {
            this.posC = address.posC
            this.posP = address.posP
            this.provinceId = address.provinceId
            this.cityId = address.cityId
            console.log(address)
        },
        onGetAddressInfo(res) {
            this.getShopList({ provinceId: this.$route.query.pid, cityId: this.$route.query.cid, posP: res.province, posC: res.district })
        },
        onClickLeft() {
            this.windowPush('/person')
        },
        onClickRight() {
            this.windowPush('/redirect')
        },
        // 详情
        handleDetail(row) {
            this.windowPush(`/shop-detail?id=${row.id}`)
        },
        // 门店分布
        handleMap({ posP, posC, provinceId, cityId }) {
            this.windowPush(`/map?map=1&posP=${posP}&posC=${posC}&pid=${provinceId}&cid=${cityId}`)
        },
        // 导航
        handleAddr(row) {
            const { longitude, latitude, name } = row
            this.windowPush(`/map-navigation?endLng=${longitude}&endLat=${latitude}&toName=${name}&posP=${this.posP}&posC=${this.posC}&pid=${this.provinceId}&cid=${this.cityId}`)
        },
        getShopList({ provinceId, cityId, posP, posC }) {
            const params = {
                page: 1,
                page_size: 1000
            }
            if (provinceId) params.provinceId = provinceId
            if (provinceId && cityId) params.cityId = cityId
            this.posP = posP
            this.posC = posC
            this.shopLoading = true
            api.getShopList(params).then((res) => {
                if (res.data.list) {
                    this.shopList = res.data.list
                }
                this.shopLoading = false
            }).catch(() => {
                this.shopLoading = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
